import { useEffect } from 'react';
import type { Experiments } from '@wix/yoshi-flow-editor';
import { CalendarStatus } from '../ViewModel/widgetViewModel/widgetViewModel';
import type { ResetCalendarStatus } from '../Actions/resetCalendarStatus/resetCalendarStatus';

/**
 * Resets calendar status from NAVIGATING to IDLE when page is restored from cache (bfcache).
 * Handles back navigation from browser back button or booking form back button.
 */
export const useBfcacheStatusReset = ({
  status,
  resetCalendarStatus,
  experiments,
}: {
  status: CalendarStatus;
  resetCalendarStatus: ResetCalendarStatus;
  experiments: Experiments;
}) => {
  useEffect(() => {
    if (!experiments.enabled('specs.bookings.ResetNavigatingStatusOnBack')) {
      return;
    }

    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted && status === CalendarStatus.NAVIGATING) {
        resetCalendarStatus();
      }
    };

    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [status, resetCalendarStatus, experiments]);
};
